import React from "react";
import classes from "./Service.module.css";
import { FaUser, FaPhone, FaEnvelope, FaComment } from "react-icons/fa";
import Fade from 'react-reveal/Fade';
import a from "./../../Assest/cs.png";

const Contact1 = () => {
  return (
    <div>
      <div className={classes.tc}>
        <div className={classes.tc1}>
         <div className={classes.steps}>
  <Fade leftt>

<div className={classes.s1}> 

<div className={classes.s11}> 
  <h3 className={classes.ih4}>Medical Admission Guidance </h3>
  <p className={classes.ih41}>Complete guidance for NEET UG aspirants covering MBBS, BDS, BAMS, BHMS & AYUSH courses.
We assist with college selection, cut-off analysis, preference list preparation, counselling rounds, and documentation, ensuring students make informed decisions at every step. </p>

<hr/>


</div>


<div className={classes.s11}> 
  <h3 className={classes.ih4}>Engineering Admission Guidance</h3>
  <p className={classes.ih41}>Expert support for engineering admissions through state and national-level counselling.
Includes branch selection, college comparison, merit-based guidance, choice filling, and admission formalities for government and private engineering colleges.
 </p>
<hr/>
</div>


<div className={classes.s11}> 
  <h3 className={classes.ih4}>MBBS Abroad</h3>
  <p className={classes.ih41}>End-to-end assistance for students aspiring to pursue MBBS abroad in reputed international universities.
Guidance includes country & university selection, eligibility check, admission process, documentation, visa support, and pre-departure guidance.
 </p>
    <hr/>
</div>


<div className={classes.s11}> 
  <h3 className={classes.ih4}>Career Assessment Test</h3>
  <p className={classes.ih41}>A structured assessment designed to identify a student’s interests, aptitude, strengths, and personality traits.
Helps students gain clarity about suitable career paths and academic options based on scientific evaluation. </p>
<hr/>
</div>


<div className={classes.s11}> 
  <h3 className={classes.ih4}>Career Counseling</h3>
  <p className={classes.ih41}>Personalized one-to-one career counselling for students and parents.
Focuses on goal clarity, course selection, future career planning, and decision-making support, helping students choose the right career with confidence. </p>
<hr/>
</div>



</div>
</Fade>




</div>

        </div>

        {/* ================= FORM ================= */}
        <div className={classes.tc2}>
          <form
            className={classes.form}
            action="https://formsubmit.co/help.rcginfo@gmail.com"
            method="POST"
          >
            <h1 className={classes.title2}>Please Feel Free To Ask</h1>

            <div className={classes.inputGroup}>
              <FaUser className={classes.icon} />
              <input
                type="text"
                className={classes.input}
                placeholder="Your Name"
                required
              />
            </div>

            <div className={classes.inputGroup}>
              <FaPhone className={classes.icon} />
              <input
                type="tel"
                className={classes.input}
                placeholder="Mobile Number"
                pattern="[0-9]{10}"
                required
              />
            </div>

            <div className={classes.inputGroup}>
              <FaEnvelope className={classes.icon} />
              <input
                type="email"
                className={classes.input}
                placeholder="Your Email"
                required
              />
            </div>

            {/* 🔽 Exam Dropdown */}
            <div className={classes.inputGroup}>
              <FaComment className={classes.icon} />
              <select className={classes.select} required>
                <option value="">Select Exam</option>
                <option value="neet">NEET</option>
                <option value="jee">JEE</option>
                <option value="cet">CET</option>
              </select>
            </div>

            <div className={classes.inputGroup}>
              <FaComment className={classes.icon} />
              <input
                type="text"
                className={classes.input}
                placeholder="Your Location"
                required
              />
            </div>

            <button type="submit" className={classes.hif}>
              Send
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact1;
